export default "__VITE_ASSET__DzEj$Fm$__"